<div *ngIf="!readOnly; else readOnlyTemplate">
  <div appDefaultViewContainerRef></div>
  <div>
    <button class="btn btn-info" mat-button (click)="back.emit()">
      {{'BACK_BUTTON' | translate}}
    </button>
    <button class="btn btn-info" mat-button
            [ngStyle]="{cursor: disableAlarmCreation ? 'default': 'pointer'}"
            [disabled]="disableAlarmCreation"
            (click)="exitParamView(true)">
      {{'NEXT_BUTTON' | translate}}
    </button>
  </div>
</div>

<ng-template #readOnlyTemplate>
  <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
  <div appDefaultViewContainerRef></div>
</ng-template>



